import {
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
    listAll
} from 'firebase/storage';
import {
    collection,
    addDoc,
    getDocs,
    deleteDoc,
    doc,
    query,
    where,
    orderBy,
    updateDoc
} from 'firebase/firestore';
import { storage, db } from './firebase';

// 画像をアップロード
export const uploadImage = async (file, userId) => {
    try {
        // ファイル名をユニークにするため、タイムスタンプを追加
        const timestamp = Date.now();
        const fileName = `${timestamp}_${file.name}`;
        const storageRef = ref(storage, `media/${userId}/${fileName}`);

        // ファイルをアップロード
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);

        // Firestoreにメディア情報を保存
        const mediaData = {
            userId: userId,
            fileName: fileName,
            originalName: file.name,
            fileSize: file.size,
            fileType: file.type,
            downloadURL: downloadURL,
            uploadedAt: new Date(),
            storagePath: `media/${userId}/${fileName}`
        };

        const docRef = await addDoc(collection(db, 'media'), mediaData);

        return {
            id: docRef.id,
            ...mediaData
        };
    } catch (error) {
        console.error('画像アップロードエラー:', error);
        throw error;
    }
};

// ユーザーのメディア一覧を取得
export const getUserMedia = async (userId) => {
    try {
        const q = query(
            collection(db, 'media'),
            where('userId', '==', userId)
        );

        const querySnapshot = await getDocs(q);
        const mediaList = [];

        querySnapshot.forEach((doc) => {
            mediaList.push({
                id: doc.id,
                ...doc.data()
            });
        });

        // クライアント側でソート（アップロード日時の降順）
        mediaList.sort((a, b) => {
            const dateA = a.uploadedAt?.toDate ? a.uploadedAt.toDate() : new Date(a.uploadedAt);
            const dateB = b.uploadedAt?.toDate ? b.uploadedAt.toDate() : new Date(b.uploadedAt);
            return dateB - dateA;
        });

        return mediaList;
    } catch (error) {
        console.error('メディア取得エラー:', error);
        throw error;
    }
};

// メディアを削除
export const deleteMedia = async (mediaId, storagePath) => {
    try {
        // Firestoreから削除
        await deleteDoc(doc(db, 'media', mediaId));

        // Storageから削除
        const storageRef = ref(storage, storagePath);
        await deleteObject(storageRef);

        return true;
    } catch (error) {
        console.error('メディア削除エラー:', error);
        throw error;
    }
};

// ファイルサイズを人間が読みやすい形式に変換
export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// ファイルタイプが画像かどうかをチェック
export const isImageFile = (file) => {
    return file.type.startsWith('image/');
};

// サポートされている画像形式かどうかをチェック
export const isSupportedImageFormat = (file) => {
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
    return supportedTypes.includes(file.type);
};

// メディアのalt属性を更新
export const updateMediaAlt = async (mediaId, altText) => {
    try {
        const mediaRef = doc(db, 'media', mediaId);
        await updateDoc(mediaRef, {
            altText: altText || '',
            updatedAt: new Date()
        });
    } catch (error) {
        console.error('alt属性の更新エラー:', error);
        throw error;
    }
}; 